import { HttpStatus } from '../http';

export class HttpResponse {
    public readonly responseObject: any | undefined;
    public readonly status: HttpStatus;
    public readonly statusCode: number;
    public readonly errorMessage: string | undefined;

    public constructor(status: HttpStatus, statusCode: number, responseObject?: any | undefined, errorMessage?: string | undefined) {
        this.status = status;
        this.statusCode = statusCode;
        this.responseObject = responseObject;
        this.errorMessage = errorMessage;
    }
}